import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-slate-50 text-slate-700 mt-0 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2">
          <img src="/lumberloop-logo.png" alt="LumberLoop USA" className="h-24 w-auto"/>
          <p className="mt-5 text-sm leading-relaxed text-slate-600 max-w-md font-body">
            The lead intelligence platform for building product manufacturers — capture demand, route it through your dealer network, and see what happens after the handoff.
          </p>
          <div className="mt-6 flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-[#C62828]"/>
            <span className="font-mono-ll text-[10px] tracking-[0.25em] uppercase text-slate-500">Made in America</span>
          </div>
        </div>

        <div>
          <div className="text-[11px] font-semibold uppercase tracking-[0.14em] text-[#17324D] mb-4">Platform</div>
          <ul className="space-y-2.5 text-sm">
            <li><a href="/#problem"      className="hover:text-[#C62828] transition-colors" data-testid="footer-platform">The Problem</a></li>
            <li><a href="/#solution"     className="hover:text-[#C62828] transition-colors">Solution</a></li>
            <li><a href="/#benefits"     className="hover:text-[#C62828] transition-colors" data-testid="footer-how">Benefits</a></li>
            <li><a href="/#request-demo" className="hover:text-[#C62828] transition-colors">Request Demo</a></li>
          </ul>
        </div>

        <div>
          <div className="text-[11px] font-semibold uppercase tracking-[0.14em] text-[#17324D] mb-4">Company</div>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/about"    className="hover:text-[#C62828] transition-colors">About</Link></li>
            <li><Link to="/insights" className="hover:text-[#C62828] transition-colors">Building Insights</Link></li>
            <li><Link to="/manufacturers" className="hover:text-[#C62828] transition-colors">For Manufacturers</Link></li>
            <li><Link to="/contact"  className="hover:text-[#C62828] transition-colors" data-testid="footer-contact">Request Demo</Link></li>
            <li><Link to="/login"    className="hover:text-[#C62828] transition-colors">Login</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-200 text-xs text-slate-500 px-6 lg:px-10 py-6 max-w-7xl mx-auto flex flex-col md:flex-row justify-between gap-3">
        <span>© {new Date().getFullYear()} LumberLoop USA. All rights reserved.</span>
        <div className="flex items-center gap-5 flex-wrap">
          <Link to="/terms"   className="hover:text-[#C62828] transition-colors" data-testid="footer-terms-link">Terms</Link>
          <Link to="/privacy" className="hover:text-[#C62828] transition-colors" data-testid="footer-privacy-link">Privacy</Link>
          <a href="mailto:info@lumberloopusa.com" className="font-mono-ll hover:text-[#C62828] transition-colors">info@lumberloopusa.com</a>
        </div>
      </div>
    </footer>
  );
}
